import collectCharacteristicSkillAdjsUnique from '../helpers/collectCharacteristicSkillAdjsUnique'
import collectActiveRuneSkillAdjsUnique from '../helpers/collectActiveRuneSkillAdjsUnique'
import getSkillFormulaCharacteristics from '../helpers/getSkillFormulaCharacteristics'
import loadSpecificSkillAdjs from '../helpers/loadSpecificSkillAdjs'
//--------------------
// process skill adjs
//--------------------
export default function processSkillAdjs({ skill, character }) {
  console.log('------------------------')
  console.log('IN processSkillAdjs skill = ', skill)

  if (!skill || !character) {
    console.error('ERROR: Missing skill or character in processSkillAdjs')
    return { skill, character }
  }
  console.log('++++++++++++++++++++++++++++++++++++++++')
  console.log('skill.name:', skill.name)
  console.log('skill.display_name:', skill.display_name)
  console.log('skill.parent_name:', skill.parent_name)
  console.log('skill.formula:', skill.formula)
  console.log('++++++++++++++++++++++++++++++++++++++++')
  /*
      The following adjs arrays are initially downloaded from the db on initial skill load for existing skills.
      Clearly for a NEW SKILL these need to be built whilst waiting for the new skill to be committed to the db:
      
      The includes:
      NA. NO COLLECT (none for NEW skill) - character.skills.character_skill_adjs e.g. +10 Stealth [CharacterSkillAdjs]
      A. COLLECT - character.skills.characteristic_skill_adjs e.g. -5 armour dex pen [CharacteristicSkillAdjs]
      B. COLLECT - character.skills.integrated_rune_skill_adjs e.g. +5 Stealth from Shadow Rune [RuneSkillAdjs]

      NB: This is not characteristic adjs (e.g. +1 dex) as those are applied at characteristic level e.g. str, dex, etc
     
      **** for this skill specifically i.e. adjs that would appear in adjs mgt for this skill ****

      EXAMPLE: Darkness Rune requires Runecasting Skill - Darkness has Stealth adj to be applied to 
      the Stealth skill NOT the new Runecasting skill (so in this case no adjs added to skill at all here)
              
      */
  console.log('0. character skill_adjs IN processSkillAdjs = ', character.skill_adjs)
  //====================================================================================
  // A. get characteristics for new skill formula e.g. str, dex, etc [where no parent]
  //------------------------------------------------------------------------------------
  const isParentBasedSkill = !!skill.parent_name
  let skill_characteristics = isParentBasedSkill ? [] : getSkillFormulaCharacteristics(skill)
  console.log('1. skill_characteristics = ', skill_characteristics)

  let characteristic_skill_adjs = isParentBasedSkill
    ? []
    : collectCharacteristicSkillAdjsUnique({
        characteristicSkillAdjs: character.characteristic_skill_adjs,
        characteristicNames: skill_characteristics,
      })
  //--------------------------------------------------------
  // assign characteristics adjs to new skill (e.g. +1 dex)
  //--------------------------------------------------------
  skill.characteristic_skill_adjs = characteristic_skill_adjs ? characteristic_skill_adjs : []
  console.log('2. skill.characteristic_skill_adjs = ', skill.characteristic_skill_adjs)
  //====================================================================================
  // B. get unique integrated/active rune skill adjs for MATCHING skill name
  //-------------------------------------------------------------------------
  // e.g. for stealth skill - go get stealth related rune adjs
  //-------------------------------------------------------------------------
  let integrated_active_runes = character.runes
    ? character.runes.filter((rune) => rune.integrated && rune.active)
    : []
  console.log('3. integrated_active_runes = ', integrated_active_runes)
  console.log('4. off to collect integrated rune skill adjs for new skill:', skill.name)
  //------------------------------------
  // where have integrated active runes
  //------------------------------------
  if (integrated_active_runes && integrated_active_runes.length > 0) {
    console.log(
      '4b. BEFORE collect - skill.integrated_rune_skill_adjs = ',
      skill.integrated_rune_skill_adjs,
    )
    //----------------------------------------------------
    // get integrated rune skill adjs matching skill name
    //----------------------------------------------------
    let integrated_rune_skill_adjs = collectActiveRuneSkillAdjsUnique({
      runes: integrated_active_runes,
      skillName: skill.name,
    })
    console.log(
      '5. integrated_rune_skill_adjs returned from collect = ',
      integrated_rune_skill_adjs,
    )
    //------------------------------------------
    // assign integrated rune adjs to new skill (create shallow copy to break reactivity)
    //------------------------------------------
    skill.integrated_rune_skill_adjs = integrated_rune_skill_adjs
      ? [...integrated_rune_skill_adjs]
      : []
    console.log(
      '6. skill.integrated_rune_skill_adjs AFTER assignment LENGTH = ',
      skill.integrated_rune_skill_adjs.length,
    )
    console.log(
      '6b. skill.integrated_rune_skill_adjs AFTER assignment JSON = ',
      JSON.stringify(skill.integrated_rune_skill_adjs),
    )
    console.log(
      '6c. skill.integrated_rune_skill_adjs AFTER assignment = ',
      skill.integrated_rune_skill_adjs,
    )
  } else {
    skill.integrated_rune_skill_adjs = []
    console.log('7. no integrated active runes found for new skill:', skill.name)
  }
  //---------------------------------------------------------------------------------------
  // load specific skill adjs for NEW skill [build adj reasons / create skill_adj entries]
  //---------------------------------------------------------------------------------------
  console.log('8. off to load specific skill adjs for new skill:', skill.name)
  console.log('9. character skill_adjs BEFORE loadSpecificSkillAdjs = ', character.skill_adjs)

  const res = loadSpecificSkillAdjs({ skill, character })
  //---------------
  // load response
  //---------------
  if (res && res.skill) {
    skill = res.skill
    character = res.character
  } else {
    console.error('Error loading specific skill adjs for skill = ' + skill.name)
  }
  console.log('10. character skill_adjs AFTER loadSpecificSkillAdjs = ', character.skill_adjs)
  //--------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers)
  //--------------------------------------------------------------
  return { skill, character }
}
